export class StepsData
{

    public static Items = [
        {
            name: 'Registro de local nuevo',
            active: false,
            completed: true,
            index: 1,
            key: 'COMPLETED'
        },
        {
            name: 'Revisión de documentos',
            active: false,
            completed: false,
            index: 2,
            key: 'ATTENDED'
        },
        {
            name: 'Visita al local',
            active: false,
            completed: false,
            index: 3,
            key: 'VISIT-LOCAL'
        },
        {
            name: 'Firma de contrato',
            active: false,
            completed: false,
            index: 4 ,
            key: 'SIGNATURE-CONTRACT'
        }
    ];


}
